module.exports = __webpack_public_path__ + "static/assets/64805bb05c3683ae57d1e86302b3e8a0.gif";